import { ThemeColor } from '@/enums'
import { CheckLine, CheckThin } from '@/icons'
import { Typography } from '../Typography'
import { InnerContainer, InnerContainerB, OuterContainer } from './styles'

export interface CheckBoxProps
  extends React.ComponentProps<typeof OuterContainer> {
  checked?: boolean
  disabled?: boolean
  onChange?: (checked: boolean) => void
  label: string
}

export const CheckBox = ({
  checked,
  disabled,
  onChange,
  label,
  ...rest
}: CheckBoxProps) => (
  <OuterContainer
    onClick={() => {
      if (!disabled) onChange?.(Boolean(checked))
    }}
  >
    <InnerContainer {...rest} checked={checked} disabled={disabled}>
      {checked && <CheckLine color={ThemeColor.b0} size="tag" />}
    </InnerContainer>
    {label && (
      <Typography
        color={rest.error ? ThemeColor.danger1 : ThemeColor.b100}
        variant="p2Body"
      >
        {label}
      </Typography>
    )}
  </OuterContainer>
)

export const CheckBoxB = ({
  checked,
  disabled,
  onChange,
  label,
  ...rest
}: CheckBoxProps) => (
  <OuterContainer
    onClick={() => {
      if (!disabled) onChange?.(Boolean(checked))
    }}
  >
    <InnerContainerB {...rest} checked={checked} disabled={disabled}>
      {checked && <CheckThin size={20} />}
    </InnerContainerB>
    {label && (
      <Typography color={ThemeColor.b50} variant="p2Body">
        {label}
      </Typography>
    )}
  </OuterContainer>
)
